// css =>
import "../../BaseStructure.css";
import Styled from "./inputBox.module.css";

// types =>
import INPUT_BOX_TYPE from "./inputBoxType";

// React =>
import { forwardRef } from "react";

const InputBox = forwardRef<HTMLInputElement, INPUT_BOX_TYPE>(
    ({ inputType, maxLenght, inputTittle, value, defaultValue, placeHolder, isDisable, onChange }, ref) => {

        const convertPersianToEnglish = (str: string) => {
            const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            
            return str.split('').map(char => {
                const index = persianNumbers.indexOf(char);
                return index !== -1 ? englishNumbers[index] : char;
            }).join('');
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            e.target.style.backgroundColor = "white";

            if (inputType === "tel") {
                let numericValue = convertPersianToEnglish(e.target.value);
                numericValue = numericValue.replace(/[^0-9]/g, '');

                if (numericValue === "") {
                    numericValue = '09';
                }

                if (numericValue.length < 2 || !numericValue.startsWith('09')) {
                    numericValue = '09';
                } else if (numericValue.length > 2) {
                    numericValue = '09' + numericValue.replace(/^09/, '');
                }
                e.target.value = numericValue;
            }

            onChange?.(e);
        };

        return (
            <>
                {
                    inputType === "text" || inputType === "email" ? (
                        <div className="row">
                            <div className={`col-1 ${ Styled.TittleSection } `}>
                                <h3>{ inputTittle }</h3>
                            </div>

                            <div className={`col-10 ${ Styled.FirstTextAreaFrame } `}>
                                <div className={`col-12 ${ Styled.InputBoxSection } `}>
                                    <input
                                        className={ Styled.TextAreaBox }
                                        type={ inputType }
                                        maxLength={ maxLenght }
                                        ref={ ref }
                                        value={ value }
                                        defaultValue={ defaultValue }
                                        placeholder={ placeHolder }
                                        disabled={ isDisable }
                                        onChange={ handleChange }
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className={`col-1 ${ Styled.TittleSection } `}>
                                <h3>{ inputTittle }</h3>
                            </div>

                            <div className={`col-4 ${ Styled.InputBoxSectionFrame } `}>
                                <div className={`col-12 ${ Styled.InputBoxSection } `}>
                                    <input
                                        type={ inputType }
                                        maxLength={ maxLenght }
                                        ref={ ref }
                                        value={ value }
                                        defaultValue={ defaultValue }
                                        placeholder={ placeHolder }
                                        disabled={ isDisable }
                                        onChange={ handleChange }
                                        style={{ textAlign: inputType === "tel" ? "left" : "right" }}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
            </>
        );
    }
)

export default InputBox;
